import { Children, cloneElement } from 'react';

import { useApplicantPutQueryById } from '../../Common/Queries/applicantQueries';

export const formatApplicantPhone = (phone = '') => {
  const rawPhone = String(phone).trim();
  const digits = rawPhone.replace(/\D/g, '');

  if (!digits) return rawPhone;
  if (rawPhone.startsWith('+')) return `+${digits}`;
  if (digits.length === 10) return `+91${digits}`;
  if (digits.startsWith('91')) return `+${digits}`;

  return rawPhone;
};

const formatReqData = (values) => {
  const formattedPhone = formatApplicantPhone(values.phone);
  return {
    phone: formattedPhone,
    email: values.email,
    name: values.name,
    status: values.status,
    createdBy: values.createdBy,
    links: values.links,
  };
};
export function EditApplicantContainer(props) {
  const { data, children } = props;
  const putToApplicant = useApplicantPutQueryById();

  const handleSubmit = (finalValues) => {
    const reqBody = formatReqData(finalValues);
    const reqParams = { reqBody, reqId: finalValues?.id };
    putToApplicant.mutate(reqParams);
  };

  return Children.only(cloneElement(children, { data, putToApplicant, handleSubmit }));
}
